export const getContraref = async (resource, id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contraref/${id}`).then(
    (response) => {
      result = response.body.contraref[0];
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const getContrarefPatientId = async (resource, id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contrarref/find_by_patient_id/${id}`).then(
    (response) => {
      result = response.body.data;
      console.log(result);
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const getContrarefByNodeOrigin = async (resource, id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contrarref/find_by_node_origin_id/${id}`).then(
    (response) => {
      console.log(response);
      result = response.body.contrarefs;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const getContrarefByNodeOriginAndPatientId = async (resource, stablishment, patient_id, page = 1) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}contraref/find_by_node_origin_id_patient_id_paginate/${stablishment}/${patient_id}?page=${page}`
    )
    .then(
      (response) => {
        console.log(response);
        result = response.body.contrarefs;
      },
      (response) => {
        console.log(response);
      }
    );
  return result;
};

export const GetContrarefFindByNodeId = async (resource, stablishment_id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contraref/find_by_node_id/${stablishment_id}`).then(
    (response) => {
      console.log(response);
      result = response.body.data;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const ExportExcelContraref = async (resource, stablishment_id) => {
  await resource
    .get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contraref/export/` + stablishment_id, {
      responseType: "blob",
    })
    .then((response) => {
      const url = URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.ms-excel",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Contrareferencias");
      document.body.appendChild(link);
      link.click();
    });
};

export const getContrarefSpecialtySigtePatientId = async (resource, node_id, specialty_sigte_id, patient_id, page = 1) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}contrarref/find_by_specialty_sigte_patient_id/${node_id}/${specialty_sigte_id}/${patient_id}?page=${page}`
    )
    .then(
      (response) => {
        result = response.body.contrarefs;
        console.log(result);
      },
      (response) => {
        console.log(response);
      }
    );
  return result;
};

export const getContrarefSpecialtySigte = async (resource, node_id, specialty_sigte_id, page = 1) => {
  let result;
  await resource
    .get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contrarref/find_by_specialty_sigte/${node_id}/${specialty_sigte_id}?page=${page}`)
    .then(
      (response) => {
        result = response.body.contrarefs;
        console.log(result);
      },
      (response) => {
        console.log(response);
      }
    );
  return result;
};

export const getContrarefNodeIdPatientId = async (resource, node_id, patient_id, page = 1) => {
  let result;
  await resource
    .get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contrarref/find_by_node_id_patient_id/${node_id}/${patient_id}?page=${page}`)
    .then(
      (response) => {
        result = response.body.contrarefs;
        console.log(result);
      },
      (response) => {
        console.log(response);
      }
    );
  return result;
};

export const getContrarefNodeId = async (resource, node_id, page = 1) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contraref/find_by_node_id_paginated/${node_id}?page=${page}`).then(
    (response) => {
      result = response.body.contrarefs;
      console.log(result);
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};
